import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;
// Default Query
export const defaultQueryFn = async ({ queryKey }) => {
  const { data } = await axios.get(`${api_base_url}${queryKey[0]}`);
  return data;
};
